import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerFormularioIdentificativoRifiutiModalComponent} from './worker-formulario-identificativo-rifiuti-modal';

export const WorkerFormularioIdentificativoRifiutiModalModule: string = ng
    .module('worker-formulario-identificativo-rifiuti-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFormularioIdentificativoRifiutiModalComponent', WorkerFormularioIdentificativoRifiutiModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-formulario-identificativo-rifiuti-modal/worker-formulario-identificativo-rifiuti-modal.module.ts